export default {
  recievedByUser: 'Message recieved by the person',
  sent: 'Message sent',
  sendingMessage: 'Sending message',
  errorSending: 'Error sending message',
  read: 'Message read',
  dropHere: 'Drop files here',
  errorUpload: 'Error uploading file',
  errorMultiple: 'You can\'t send multiple files at the same time',
  uploadImageError: 'Error loading images',
  closeConversation: 'Close conversation',
  transferConversation: 'Transfer conversation',
  mine: 'Mine',
  all: 'All',
  waiting: 'Waiting',
  connectChannels: 'Connect channels',
  pin: 'Pin',
  unpin: 'Unpin',
  noResults: 'No results',
  yourLine: 'Your line',
  noResult: 'There are no new messages',
  hadAnError: 'An error has occurred',
  retry: 'Retry',
  internalRoomUsers: 'Users',
  addInternalRoomUsers: 'Add user',
  transferRoom: 'Transfer conversation',
  transferRooms: 'Transfer conversations',
  closeRoom: 'Close conversation',
  closeRooms: 'Close conversations',
  pinConversation: 'Pin conversation',
  unpinConversation: 'Unpin conversation',
  maxPinnedRooms: 'You have reached the maximum number of pinned conversations',
  unpinConversations: 'Unpin conversations',
  pinConversations: 'Pin conversations',
  roomSelected: 'Conversation selected',
  roomsSelected: 'Conversations selected',
  wizardFilter: 'Keybe Assistance',
  closedByAi: 'Closed by AI',
  billingReportConversations: 'Billing Report conversations',
  countryCode: 'Country code',
  totalMessages: 'Total messages',
  automatedMessages: 'Automated messages',
  proactiveLegacyMessages: 'Legacy proactive messages',
  proactiveMessagesUIC: 'UIC proactive messages',
  proactiveMessagesBIC: 'BIC proactive messages',
  proactiveMessagesByCountryLegacy: 'Legacy proactive messages by country',
  proactiveMessagesByCountryUIC: 'UIC proactive messages by country',
  proactiveMessagesByCountryBIC: 'BIC proactive messages by country',
  multimediaMessages: 'Multimedia messages',
  outSessionMessagesDelivered: 'Delivered session messages (out)',
  inSessionMessagesDelivered: 'Delivered session messages (in)',
  assinedFreelines: 'Assined freelines',
  sessionMessagesDelivered: 'Delivered session messages',
  yourLineIsDisconnected: 'Your line is disconected!',
  lineDisconnectedSubtitle: 'You cannot send or recieve messages with a line with no connection',
  selectTheFileYouWantToSend: 'Select the file you want to send',
  ofDragTheFileHere: 'Or drag the file here',
  completed: 'Completed',
  hello: 'Hello',
  messageCantBeEmpty: 'Message cannot be empty',
  allParametersMustBeFilled: 'All parameters must be filled out',
  mustSelectATemplate: 'You must select a template',
  noQuickResponsesFound: 'Didnt find any quick responses',
  fileLink: 'File link',
  openFile: 'Open file',
  quickResponsesPressESC: 'Quick responses (Press ESC to go back)',
  disabledOnIg: 'Instagram doesnt have this option for the moment',
  fileExtensionInvalid: 'File extension invalid',
  messageInfo: 'Message info',
  reply: 'Reply',
  sendBy: 'Sent by',
  errorCreatingExtradata: 'Error creating extradata',
  chatBubble: 'Chat bubble',
  chatBubbleSize: 'Chat bubble size',
  small: 'Small',
  medium: 'Medium',
  large: 'Large',
  manageSales: 'Manage tickets and sales',
  extraLarge: 'Extra large',
  darkMode: 'Dark mode',
  quickFilterClosed: 'Closed',
  quickFilterClosedByAi: 'By AI',
  quickFilterClosedByAdvisor: 'By me',
  quickFilterMine: 'Active',
  closedByMe: 'Closed by me',
  filtersTutorialStatus: 'New chat control bar!',
  filtersTutorialStatus2: 'Set yourslef as Active/Inactive in a faster way',
  filtersTutorialSound: 'Deactivate notifications with one click',
  filtersTutorialSound2: 'Activate or deactivate sound notifications with one click!',
  filtersTutorialQuickFilters: 'And even faster quick filters',
  filtersTutorialQuickFilters2: 'Don\'t miss any conversation, we added the "closed by AI" filter within Closed, to optimize your conversation management',
  togetherHashtag: '#TogetherWeWillMakeItPossible',
  darkModeTutorial: 'Settings',
  darkModeTutorial2: 'You choose! define the mode you like the most to configure your app',
  multipleExtradataEditTutorial: 'Move between text fields with TAB and edit people\'s data faster',
  multipleExtradataSaveTutorial: 'Save all the changes with just one click',
  newsDialogTitle: 'Breaking News!! 🚨',
  newsDialogMessage: 'In case you haven\'t noticed, KB now recommends smart responses by',
  newsDialogMessage1: 'understanding the context of the conversation and learning from each interaction.',
  newsDialogImportant: 'Important: ',
  newsDialogMessage2: 'Increase your efficiency by over 40% and boost your sales with Keybe  💸',
  newsDialogMessage3: 'Starting at USD $0.0022 per suggestion',
  newsDialogMessage4: 'Learn more about ',
  newsDialogMessage5: 'Smart Chat here',
  newsDialogMessage6: '🚀',
  instagramFixDialog: '📣 We have something important to tell you: In order to continue providing the best service, we will be making adjustments to the Meta integration with Instagram. You may experience intermittent connection issues during these days, but we will let you know as soon as we have any updates.',
  instagramFixDialog1: '🔝 Thank you for your understanding and happy holidays!',
  writeYourMessageHere: 'Write your message here',
  firstBanner: '🚨 KB:’s works under a prepaid subscription. Remember to always keep a balance loaded to sell better with Artificial Intelligence.',
  secondBanner: 'Positive balance and sales arriving 😀 Don\'t forget to recharge your balance to keep selling with the power of Smart Chat.',
  domainDialogText: 'Remember if you\'re in the Keybe Ai app you must enter Keybe from',
  domainDialogText2: 'this URL',
  loadMoreRooms: 'Load more chats',
  roomSearchTooltip: 'Enter at least 5 characters to search',
  favorites: 'Favorites'
}
